import React from 'react';

import './home.css'

import { Link } from "react-router-dom";


import Header from "../../Header";

import cadre from '../../../assets/images/cadreme.png';
import order from '../../../assets/images/order.png';


import birth from '../../../assets/images/birth.jpg';
import weed from '../../../assets/images/homeweeding.jpeg';
import baby from '../../../assets/images/baby.jpg';
import mini from '../../../assets/images/mini.jpg';

import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';


const Home = ({ openBurger, isOpen }) => {

    return (
        <div className="home">
            <Header openBurger={openBurger} isOpen={isOpen} title='Confection de cake design' />
            <div className="main">
                {/* <Gallery /> */}
                <div className="home-categories">
                    <div className="weeding-birth">
                        <div className="card card-birth " >
                            <Fade left>
                                <Link to="/anniversaire">

                                    <img className="card-birth-image " src={birth} alt='logo' />
                                </Link>

                            </Fade>
                            <h2>GÂTEAUX DE FÊTE</h2>
                            <p className="small-para">Mes gâteaux sont non seulement originaux et personnalisés mais aussi bien plus qu’un simple dessert, ils feront partie du souvenir merveilleux d’un jour très important.</p>
                        </div>
                        <div className="card card-weed">
                            <Fade left>
                                <Link to="/mariage">
                                    <img className="card-weed-image " src={weed} alt='logo' />
                                </Link>
                            </Fade>
                            <h2>GÂTEAUX DE MARIAGE</h2>
                            <p className="small-para">Le mariage est l'un des événements les plus important de la vie. C'est pourquoi nous prenons le temps de faire le gâteau de vos rêves.</p>
                        </div>
                        <div className=" baby-cat">
                            <Fade left>
                                <Link to="/baby-shower">
                                    <img className="card-weed-image" src={baby} alt='logo' />
                                </Link>
                            </Fade>
                            <div className="card-weed-para">
                                <h2 className="titletwo">GÂTEAUX DE NAISSANCE</h2>
                                <p className="small-para">Profitez de chaque minute, elle passe trop vite. Profitez de chaque heure, elle vous apporte tant de joie. Profitez de chaque jour, il vous apporte toujours une expérience. Un gâteau unique pour une naissance inoubliable</p>
                            </div>
                        </div>
                        <div className=" baby-cat">
                            <Fade left>
                                <Link to="/mignardises">
                                    <img className="card-weed-image" src={mini} alt='logo' />
                                </Link>
                            </Fade>
                            <div className="card-weed-para">
                                <h2 className="titletwo">MIGNARDISES</h2>
                                <p className="small-para">"Nul n'est heureux que le gourmand"</p>
                            </div>
                        </div>

                    </div>

                </div>
                <div className="about">
                        <img className="about-logo" src={cadre} alt='logo' />
                    <div className="about-description">
                        <h2 className="about-title">Qui suis-je ?</h2>
                        <Zoom>

                            <p className="about-about" > Cake designer diplômée, passionnée de pâtisserie &#x2764;&#xFE0F; &#128525;.<br />
                        J’ai créé ma petite entreprise artisanale de cake design et j’y exerce aujourd’hui ma passion.<br />
                        Vous trouverez ici des gâteaux sur-mesure et délicieux, confectionnés maison.</p>
                        </Zoom>

                    </div>
                </div>

                <div className="about order">
                 <img className="about-logo order-logo" src={order} alt='logo' /> 
                    <div className="about-description order-description">
                        <h2 className="about-title order-title">Comment commander ?</h2>
                        <Zoom>

                            <p>Envoyer un message par mail, insta ou telephone, avec la date souhaitée, le thème et le nombre de parts pour avoir un devis.<br />
                        N'hésitez pas à bien détailler vos envies, design...<br />
                        Passer votre commande le plus tôt possible.</p>
                        </Zoom>

                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default Home;